import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function ShieldIcon(props: SvgIconProps) {
  const fill = props.fill ?? props.color ?? '#3B3C40';
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.5 3.375H4.5C4.00272 3.375 3.52581 3.57254 3.17417 3.92417C2.82254 4.27581 2.625 4.75272 2.625 5.25V10.5C2.625 15.5897 5.0925 18.6769 7.1625 20.3709C9.38531 22.1887 11.61 22.8084 11.7037 22.8356C11.8978 22.8881 12.1022 22.8881 12.2963 22.8356C12.39 22.8094 14.6147 22.1887 16.8375 20.3709C18.9075 18.6769 21.375 15.5897 21.375 10.5V5.25C21.375 4.75272 21.1775 4.27581 20.8258 3.92417C20.4742 3.57254 19.9973 3.375 19.5 3.375ZM19.125 10.5C19.125 13.8478 17.8978 16.5647 15.4772 18.5766C14.4396 19.4327 13.2637 20.1058 12 20.5669C10.7362 20.106 9.56023 19.4329 8.52281 18.5766C6.10219 16.5647 4.875 13.8478 4.875 10.5V5.625H19.125V10.5Z'
        fill={fill}
      />
    </SvgIcon>
  );
}
